// extracted by mini-css-extract-plugin
export default {"create":"CreateTemplate-module__create__M--mq","text":"CreateTemplate-module__text__-wRTU","templates":"CreateTemplate-module__templates__pVe0O"};